import React from 'react';

export const MessageExitUpgrade = (): React.JSX.Element => (
  <>
    Your upgrade is not fully scheduled and confirmed.
    <br />
    Do you still want to exit?.
  </>
);
export const MessageSessionEnding = (): React.JSX.Element => (
  <>
    Your session will expire in the next 5 minutes
    <br />
    Would you like to keep working?
  </>
);
